import React from "react";
import BottomSheetLayout from "../../../../../components/BottomSheetLayout";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import CustomAutoComplete from "../../../../../components/CustomAutoComplete";
import RubbishSVG from "../../../../../../media/images/icons/rubish-icon";
import { grey } from "@mui/material/colors";

interface Props {
  open: boolean;
  onDismiss: React.Dispatch<React.SetStateAction<boolean>>;
  onOk: () => void;
  handleResetForm: () => void;
  handleChangeAutoComplete: (selected: any, type?: string) => void;
  goodsType: {
    value: any | null;
    inputValue: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    goodsTypes: any[];
  };
  loaderGroup: {
    value: any | null;
    inputValue: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    loaderGroups: any[];
  };
  packageType: {
    value: any | null;
    inputValue: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    packageTypes: any[];
  };
  origin: {
    value: any | null;
    inputValue: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    origins: any[];
  };
  destination: {
    value: any | null;
    inputValue: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    destinations: any[];
  };
}

export default function FiltersBottomSheet(props: Props) {
  const {
    onDismiss,
    open,
    handleChangeAutoComplete,
    goodsType,
    loaderGroup,
    packageType,
    origin,
    destination,
    handleResetForm,
    onOk,
  } = props;

  const theme = useTheme();
  return (
    <BottomSheetLayout height="100%" open={open} onDismiss={onDismiss}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "16px 16px 12px 16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              color: theme.palette.secondary[600],
              fontWeight: "700",
            }}
          >
            فیلترهای بار
          </Typography>

          <CustomButton
            // loading={loading}
            disabled={
              !(
                goodsType.value ||
                loaderGroup.value ||
                packageType.value ||
                origin.value ||
                destination.value
              )
            }
            onClick={() => handleResetForm()}
            flexDirection="row"
            title="حذف فیلترها"
            justifyContent="center"
            bgColor="error.main"
            fSize="14px"
            fWeight="700"
            px="10px"
            py="10px"
            borderRadius="10px"
            icon1={<RubbishSVG size={22} />}
          />
        </Box>

        <Box
          sx={{
            marginTop: "16px",
            flex: "1",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Grid container>
            <Grid item xs={3}>
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  marginTop: "10px",
                  color: theme.palette.primary[700],
                }}
              >
                نوع محموله
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomAutoComplete
                width="100%"
                flex={1}
                height="44px"
                mb="0px"
                borderRadius="10px"
                inputValue={goodsType.inputValue}
                setInputValue={goodsType.setValue}
                type={"goodType"}
                placeHolder="نوع محموله"
                setValue={handleChangeAutoComplete}
                value={goodsType.value}
                // error={loaderType.error}
                // errorMessage={loaderType.errorMessage}
                options={goodsType.inputValue ? goodsType.goodsTypes : []}
                // innerIcon={
                //   <LocationOutline size={18} color={theme.palette.textColor.light} />
                // }
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={3}>
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  marginTop: "10px",
                  color: theme.palette.primary[700],
                }}
              >
                گروه بارگیر{" "}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomAutoComplete
                width="100%"
                flex={1}
                height="44px"
                mb="0px"
                borderRadius="10px"
                inputValue={loaderGroup.inputValue}
                setInputValue={loaderGroup.setValue}
                type={"loaderGroup"}
                placeHolder="گروه بارگیر"
                setValue={handleChangeAutoComplete}
                value={loaderGroup.value}
                // error={loaderType.error}
                // errorMessage={loaderType.errorMessage}
                options={loaderGroup.inputValue ? loaderGroup.loaderGroups : []}
                // innerIcon={
                //   <LocationOutline size={18} color={theme.palette.textColor.light} />
                // }
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={3}>
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  marginTop: "10px",
                  color: theme.palette.primary[700],
                }}
              >
                بسته‌بندی{" "}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomAutoComplete
                width="100%"
                flex={1}
                mb="0px"
                height="44px"
                borderRadius="10px"
                inputValue={packageType.inputValue}
                setInputValue={packageType.setValue}
                type={"packageType"}
                placeHolder="نوع بسته‌بندی"
                setValue={handleChangeAutoComplete}
                value={packageType.value}
                // error={loaderType.error}
                // errorMessage={loaderType.errorMessage}
                options={packageType.inputValue ? packageType.packageTypes : []}
                // innerIcon={
                //   <LocationOutline size={18} color={theme.palette.textColor.light} />
                // }
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={3}>
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  marginTop: "10px",
                  color: theme.palette.primary[700],
                }}
              >
                مبدا{" "}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomAutoComplete
                width="100%"
                flex={1}
                mb="0px"
                height="44px"
                borderRadius="10px"
                inputValue={origin.inputValue}
                setInputValue={origin.setValue}
                type={"origin"}
                placeHolder="مبدا  "
                setValue={handleChangeAutoComplete}
                value={origin.value}
                // error={loaderType.error}
                // errorMessage={loaderType.errorMessage}
                options={origin.inputValue ? origin.origins : []}
                // innerIcon={
                //   <LocationOutline size={18} color={theme.palette.textColor.light} />
                // }
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={3}>
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  marginTop: "10px",
                  color: theme.palette.primary[700],
                }}
              >
                مقصد{" "}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomAutoComplete
                width="100%"
                flex={1}
                mb="0px"
                height="44px"
                borderRadius="10px"
                inputValue={destination.inputValue}
                setInputValue={destination.setValue}
                type={"destination"}
                placeHolder="مقصد  "
                setValue={handleChangeAutoComplete}
                value={destination.value}
                // error={loaderType.error}
                // errorMessage={loaderType.errorMessage}
                options={destination.inputValue ? destination.destinations : []}
                // innerIcon={
                //   <LocationOutline size={18} color={theme.palette.textColor.light} />
                // }
              />
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <CustomButton
              // loading={loading}
              onClick={() => onOk()}
              flexDirection="row"
              flex={1}
              title="اعمال فیلتر‌ها"
              justifyContent="center"
              bgColor="secondary.main"
              fSize="14px"
              fWeight="700"
              px="10px"
              py="8px"
              borderRadius="8px"
              // icon1={<RubbishSVG size={22} />}
            />
            <CustomButton
              // loading={loading}
              onClick={() => onDismiss(false)}
              rippleColor={theme.palette.primary.main}
              flexDirection="row"
              title="انصراف"
              justifyContent="center"
              borderColor="primary.main"
              bgColor={"#fff"}
              fSize="14px"
              textColor="primary.main"
              fWeight="700"
              px="16px"
              py="8px"
              borderRadius="8px"
              // icon1={<RubbishSVG size={22} />}
            />
          </Box>
        </Box>
      </Box>
    </BottomSheetLayout>
  );
}
